import React from "react";

function SvgIcMapPoi009(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 21l3.5 5h-7l3.5-5zm0-16c4.178 2.461 9 7.385 9 11.076C25 18.796 22.697 21 19.856 21A5.222 5.222 0 0116 19.326 5.226 5.226 0 0112.143 21C9.303 21 7 18.796 7 16.076 7 12.385 11.821 7.461 16 5z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi009;
